export default {
    overviewOurProduct: 'Våre produkter',
    overviewTitle: 'Kortoversikt',
    overviewIngress: 'Her kan du endre på kortene dine',
    overviewIngressNoCards: 'Vi finner ingen aktive kort',
    overviewMyCardsTitle: 'Mine kort',
    overviewOtherCardsTitle: 'Andre kort',
    overviewChildrenCardsTitle: 'Bankkort for barn og unge',
    overviewOtherCardsDescription:
        'Her vil du få oversikt over kort som er utstedt på kontoer som du disponerer og har fullmakt på',
    overviewPaymentTitle: 'Ekstra innbetaling',
    overviewTransferFromCard: 'Overføre fra kort',
    overviewPaymentIngress:
        'For deg som ønsker å betale ned hele eller deler av utestående saldo på kredittkortet ditt. Noter ned informasjonen her så har du alt du trenger for å gjøre en betaling på vanlig måte.',
    overviewPaymentIngress2: 'Trykk på ikonet for å kopiere.',
    overviewPaymentAccount: 'Til konto',
    overviewPaymentCopied: 'Kopiert',
    overviewDetailsTitle: 'Kortinformasjon',
    overviewDetailsStatus: 'Status',
    overviewDetailsKID: 'KID nummer',
    overviewDetailsProduct: 'Produkt',
    overviewDetailsAccountNumber: 'Kontonummer',
    overviewDetailsInnbetaling: 'Innbetalingskonto',
    overviewDetailsExpires: 'Utløpsdato',
    overviewDetailsInvoice: 'Forfallsdato',
    overviewDetailsInvoiceDate: 'Fakturadato',
    overviewDetailsInvoiceDueDate: '.hver måned',
    overviewDetailsSaldo: 'Saldo',
    overviewDetailsUsed: 'Brukt',
    overviewDetailsAvailable: 'Tilgode',
    overviewDetailsCardLimit: 'Kredittgrense',
    overviewDetailsCardOwner: 'Korteier',
    overviewDetailsCardAccountOwner: 'Kontoeier',
    overviewDetailsCardNumber: 'Kortnummer',
    overviewDetailsCardType: 'Type',
    overviewDetailsCardTypeCredit: 'Kredittkort',
    overviewDetailsCardTypeDebit: 'Debitkort',
    overviewDetailsCardName: 'Kortnavn',
    overviewDetailsAdditionalText: 'Tilleggstekst',
    overviewDetailsNafMemberNumber: 'Medlemsnummer',
    overviewRedirectWarningTitle: 'Videresending',
    overviewRedirectWarningTextGeneric: 'Du vil nå bli videresendt til',
    overviewRedirectWarningTextPre: 'Du vil nå bli videresendt til',
    overviewRedirectWarningTextPost:
        'som formidlet dette kortet for å søke om økning av kredittgrense. Du må sannsynligvis logge inn på nytt.',
    overviewRedirectWarningConfirm: 'Ja, ta meg dit',
    overviewCardBlocked: 'Sperret',
    overviewCardOrdered: 'Bestilt',
    overviewCardSoftBlocked: 'Låst',
    overviewCardExpired: 'Fornyes',
    overviewCardStatusPre: 'Kortet er',
    overviewTotalCredit: 'Tilgjengelig kreditt',
    overviewTotalDebit: 'Totalt disponibelt',
    overviewCardEmptyTitle: 'Ønsker du kredittkort?',
    overviewCardEmptyText: 'Søk her og få svar med en gang',
    overviewDebitCardEmptyTitle: 'Ønsker du bankkort?',
    overviewDebitCardEmptyText: 'Gå til bestilling',
    overviewOrderStatusOrdered: 'Bestilling sendt',
    overviewOrderStatusSentToProduction: 'Sendt til produksjon',
    overviewOrderStatusProductionStarted: 'Produksjon startet',
    overviewOrderStatusSentToCustomer: 'Sendt til kunde',

    noCardsAvailableTitle: 'Du har ingen kort hos oss',
    noCardsAvailableDescription: 'Du kan enkelt bestille kort hos oss, velg det som passer deg best',

    messageFetchCardsForCardsOverviewError: 'Noe gikk galt ved henting av kortene dine.',

    orderCardBankCardOption: 'Bestill bankkort',
    orderCardBankCardDescription: 'Trenger du flere kort? Bestill her',
    orderCardCreditCardOption: 'Søk om kredittkort',
    orderCardBankCardOnSharedAccountOption: 'Bestill nytt kort til felleskonto',
    orderCardBankCardOnSharedAccountDescription: 'Gjør det lettere å dele samme konto med ett kort hver',

    noBankCardsAvailableTitle: 'Du har ingen bankkort',
    noBankCardsAvailableDescriptionPart1: 'Ønsker du kort til en av dine kontoer, ',
    noBankCardsAvailableDescriptionPart2: 'trykker du på knappen under.',
    noBankCardsAvailableDescriptionPart2NoAvailableAccounts: 'tar du kontakt med banken din.',
    goToV3: 'Gå til V3',
};
